<template>
  <li :class="['nav-item', {'right': node.level === 0}, {'active': this.$store.state.activeMenu===data.path}]"
    :key="data.path" @click.stop="onItem(data)">
    <a href="javascript:;" :class="['nav-item-a text-nowrap']">
      <span class="nav-a-0 font-16" v-if="node.level === 0">
        {{data.name}}
      </span>
      <SkewButton v-else class="menu-skew" :class="{'font-16 weight-bold': data.children && data.children.length > 0}"
        :text="data.name"></SkewButton>
    </a>
    <slot name="subMenu"></slot>
  </li>
</template>

<script>
import SkewButton from '@/components/button-skew'
export default {
  name: 'menu-item',
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    node: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  components: {
    SkewButton
  },

  data () {
    return {
      activeMenu: {}
    }
  },

  methods: {
    onItem (item) {
      // 判断是否分组标题，分组不跳转
      // if (this.activeMenu.path !== item.path) {
      if (item.path && !item.group && !item.isAnchor) {
        this.$router.push({
          path: item.path
        })
      } else if (item.isAnchor) {
        this.$router.push({
          path: '/products'
        })
        this.$EventBus.$emit('selectNavigation', item)
      }

      // this.activeMenu = item
      // }
    }
  }
}

</script>

<style scoped>
  .nav-item {
    position: relative;
    padding: 0 15px;
  }

  .nav-item:hover>.level-1,
  .nav-item-a:hover+.level-1 {
    display: block;
  }

  .nav-item-a {
    position: relative;
    display: block;
    color: inherit;
    align-items: center;
    text-decoration: none;
  }

  .nav-a-0 {
    display: block;
    padding: 15px 0;
    font-weight: bold;
    /* border-bottom: 9px solid #fff; */
  }

  .active .nav-a-0,
  .nav-item:hover .nav-a-0,
  .nav-a-0:hover {
    /* border-color: #DA4026; */
  }

  .nav-item:hover .nav-a-0::before,
  .active .nav-a-0::before {
    content: '';
    display: inline-block;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 6px;
    z-index: 10;
    transform: skew(-30deg);
    background-color: #DA4026;
  }

  .level-1>.nav-item {
    float: left;
  }

  .level-2 .nav-item .nav-item-a:hover {
    color: #DA4026;
  }

  .level-2 .nav-item {
    margin-bottom: 5px;
  }

  .menu-skew {
    color: #2E3635;
    background-color: #fff;
  }

  .menu-skew:hover {
    color: #fff;
    background-color: #7B7D78;
  }

</style>
